import {
  Alert,
  EmptyState,
  ListPanel,
  ListPanelHeader,
  MessageList,
  MessageListItem,
  MessageListItemSkeleton,
} from '@all-manager/design-system-v2';
import type { MouseEvent } from 'react';
import { useConversationList } from './useConversationList';

type Props = {
  selectedConversationId?: string;
  onSelectConversation: (conversationId: string) => void;
  /** Phones show one column at a time: the back arrow returns to the conversation. */
  back?: {
    href: string;
    onClick: (event: MouseEvent<HTMLElement>) => void;
  };
};

const SKELETON_ROWS = ['first', 'second', 'third'];
const LIST_LABEL = 'Conversations avec l’assistant';

export default function ConversationList(props: Props) {
  const hook = useConversationList();

  function renderBody() {
    if (hook.isLoading) {
      return (
        <MessageList aria-label={LIST_LABEL} aria-busy>
          {SKELETON_ROWS.map((row) => (
            <MessageListItemSkeleton key={row} />
          ))}
        </MessageList>
      );
    }

    if (hook.hasError) {
      return <Alert severity="error">L’historique n’a pas pu être chargé.</Alert>;
    }

    if (hook.rows.length === 0) {
      return (
        <EmptyState
          title="Aucune conversation ce mois-ci"
          subtitle="Les questions posées à l’assistant apparaîtront ici, pour tous les membres."
        />
      );
    }

    return (
      <MessageList aria-label={LIST_LABEL}>
        {hook.rows.map((row) => (
          <MessageListItem
            key={row.id}
            sender={row.sender}
            subject={row.subject}
            preview={row.preview}
            date={row.date}
            dateTime={row.dateTime}
            selected={row.id === props.selectedConversationId}
            onClick={function handleSelect() {
              props.onSelectConversation(row.id);
            }}
          />
        ))}
      </MessageList>
    );
  }

  return (
    <ListPanel
      fill
      header={(
        <ListPanelHeader
          title="Historique"
          subtitle={hook.subtitle}
          backHref={props.back?.href}
          onBackClick={props.back?.onClick}
          backLabel="Retour à la conversation"
        />
      )}
    >
      {renderBody()}
    </ListPanel>
  );
}
